/**
 * Which paths a signed-out visitor is allowed to *see* rather than be bounced
 * to /login from.
 *
 * `/` is special: it is the URL search engines and word-of-mouth point at, so
 * a signed-out visitor gets the public landing page there instead of a
 * redirect. Every other gated path still redirects (and remembers where the
 * user was going). Kept pure so the rule is unit-tested — App.tsx cannot be.
 */
export const PUBLIC_HOME_PATH = '/';

/** True when a signed-out visitor at `pathname` should see the landing page. */
export function rendersPublicLanding(pathname: string): boolean {
  const path = (pathname.split('?')[0] ?? '').split('#')[0] ?? '';
  const normalized = path.replace(/\/+$/, '');
  return normalized === '' || normalized === PUBLIC_HOME_PATH;
}
